import React, { useEffect, useState } from 'react';
import { ProgressBar, Spinner, Alert } from 'react-bootstrap';
import { withBase, ROUTES } from '../config';

const GOAL_AMOUNT = 10000;

export default function FundraisingProgress({ refreshKey = 0 }) {
  const [totalRaised, setTotalRaised] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    setLoading(true);
    setError('');

    const url = withBase(ROUTES.total);

    fetch(url, { headers: { Accept: 'application/json' } })
      .then(res => {
        if (!res.ok) throw new Error(`HTTP ${res.status} ${res.statusText}`);
        return res.json();
      })
      .then(data => {
        const amount = typeof data === 'number' ? data : (data?.total ?? data?.amount);
        if (typeof amount !== 'number') throw new Error('Unexpected response shape');
        setTotalRaised(amount);
      })
      .catch(err => setError(err.message || 'Failed to load total'))
      .finally(() => setLoading(false));
  }, [refreshKey]);

  if (loading) {
    return (
      <div className="text-center py-4">
        <Spinner animation="border" variant="light" />
      </div>
    );
  }

  if (error) {
    return <Alert variant="danger" className="mt-3">{error}</Alert>;
  }

  const pct = Math.min(Math.round((totalRaised / GOAL_AMOUNT) * 100), 100);

  return (
    <div className="mt-4 pb-3">
      <h5 className="text-black text-center mb-3">🎯 Fundraising Progress</h5>
      <ProgressBar
        now={pct}
        label={<span style={{ color: '#000' }}>{pct}%</span>}
        variant="success"
        striped
        animated
        style={{ height: '1.5rem' }}
      />
      <div className="text-black text-center mt-2">
        Raised ${totalRaised.toLocaleString()} of ${GOAL_AMOUNT.toLocaleString()}
      </div>
    </div>
  );
}
